function relatedProductsCarousel(){
    $('.related.products ul.products').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        nextArrow: '<div class="slider__arrow"><span>›</span></div>',
        prevArrow: '<div class="slider__arrow left"><span>‹</span></div>',
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }
        ]
    });
}

export default {
    relatedProductsCarousel
};
